export default __webpack_public_path__ + "static/media/all.f33fb4a8.yaml";